module.exports = __webpack_public_path__ + "img/13.b448dbf2.png";